import React from 'react';
import { gql } from '@apollo/client';
import { AdminEntityMergeRequestItemProps } from '../../AdminEntityMergeRequestItem';
import { useLocalization } from '../../../../../../../../util/useLocalization';
import {
  useMergeRequestExternalIdMutation, MergeItemAffiliationExternalIdFragment, EntityMergeFragment_SitePerson_Fragment
} from '../../../../../../../../../gql/typings';
import AdminMergeItemBasicField from '../../components/basicField/AdminMergeItemBasicField';
import { Locale } from '../../../../../../../../../localization/LocalizationKeys';
import { Optional } from '../../../../../../../../util/StateArrayType';
import AdminMergeItemBasicConflictField from '../../components/basicConflictField/AdminMergeItemBasicConflictField';

const AdminMergeItemAffiliationExternalId: React.FC<AdminEntityMergeRequestItemProps> = (props) => {
  const info = props.item.type as MergeItemAffiliationExternalIdFragment;
  const from = props.from as EntityMergeFragment_SitePerson_Fragment;
  const to = props.into as Optional<EntityMergeFragment_SitePerson_Fragment>;
  const localization = useLocalization();

  const [setExternalId] = useMergeRequestExternalIdMutation();

  if (!props.item.hasConflict) return (
    <AdminMergeItemBasicField {...props}>
      {localization.formatMessage(Locale.Text.Merge_request_external_id_transfer_description, {
        value: <strong>{info.externalId.externalId}</strong>,
        record1: <strong>{from?.person?.fullName}</strong>,
        record2: <strong>{to?.person?.fullName}</strong>,
        externalIdType: info.externalId.type.isHeadingKey
          ? <strong>{localization.formatMessageByStr(info.externalId.type.heading)}</strong>
          : <strong>{info.externalId.type.heading}</strong>,
      })}
    </AdminMergeItemBasicField>
  );

  return (
    <AdminMergeItemBasicConflictField
      {...props}
      fromValue={info.externalId.externalId}
      toValue={info.existingExternalId?.externalId}
      updateMutation={newValue => setExternalId({
        variables: {
          existingExternalIdId: info.existingExternalId?.id ?? -1,
          removeOld: !!info.existingExternalId,
          input: {
            externalId: newValue,
            internalId: to!.id,
            externalIdTypeCode: info.externalId.type.code,
          },
        },
      })}
    >
      {localization.formatMessage(Locale.Text.Merge_request_external_id_mismatch_description, {
        id1: <strong>{info.externalId.externalId}</strong>,
        id2: <strong>{info.existingExternalId?.externalId}</strong>,
        externalIdType: info.externalId.type.isHeadingKey
          ? <strong>{localization.formatMessageByStr(info.externalId.type.heading)}</strong>
          : <strong>{info.externalId.type.heading}</strong>,
      })}
    </AdminMergeItemBasicConflictField>
  );
};

gql`
  fragment MergeItemAffiliationExternalId on AffiliationExternalId_EntityDataToBeTransferredType {
    code
    externalId {
      id
      type {
        code
        heading
        isHeadingKey
      }
      externalId
    }
    existingExternalId {
      id
      externalId
    }
  }
`;

export default AdminMergeItemAffiliationExternalId;
